import { SignInButton, SignedIn, SignedOut, UserButton, useUser } from '@clerk/clerk-react';
import { useQuery } from 'convex/react';

import { api } from '../../convex/_generated/api';

export default function Home() {
  return (
    <main className="min-h-screen flex flex-col items-center justify-center p-8 gap-6">
      <h1 className="text-3xl font-semibold">BDL — Blazers Dynasty League</h1>

      <SignedOut>
        <SignInButton mode="modal">
          <button type="button" className="px-4 py-2 rounded bg-black text-white hover:bg-gray-800">
            Sign in
          </button>
        </SignInButton>
      </SignedOut>

      <SignedIn>
        <SignedInPanel />
      </SignedIn>
    </main>
  );
}

function SignedInPanel() {
  const { user } = useUser();
  const ping = useQuery(api.health.ping);

  return (
    <section className="flex flex-col items-center gap-4">
      <div className="flex items-center gap-3">
        <UserButton afterSignOutUrl="/" />
        <p className="text-lg">Welcome, {user?.firstName ?? user?.username ?? 'friend'}.</p>
      </div>
      <pre className="text-sm bg-gray-100 rounded p-3 font-mono">
        {ping === undefined ? 'Pinging Convex...' : JSON.stringify(ping, null, 2)}
      </pre>
    </section>
  );
}
